import React, { useState } from 'react';
import { FileUpload } from '../../../dashboard_user/components/FileUpload';

interface UploadDocumentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  companies: Array<{ id: number; name: string }>;
  onUploadComplete?: () => void;
}

export const UploadDocumentDrawer: React.FC<UploadDocumentDrawerProps> = ({
  isOpen,
  onClose,
  companies,
  onUploadComplete,
}) => {
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(
    companies.length > 0 ? companies[0].id : null
  );

  if (!isOpen) return null;

  const handleUploadComplete = () => {
    if (onUploadComplete) {
      onUploadComplete();
    }
    // Optionally close drawer after successful upload
    // onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Side Drawer */}
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto">
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="px-6 py-5 border-b flex items-center justify-between flex-shrink-0" style={{ borderColor: '#E5E7EB' }}>
            <h2 className="text-xl font-bold" style={{ color: '#1F2937' }}>
              Upload Document
            </h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Form Content */}
          <div className="flex-1 px-6 py-6 overflow-y-auto">
            {/* Company Selection */}
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2" style={{ color: '#1F2937' }}>
                Select Company *
              </label>
              <select
                value={selectedCompanyId || ''}
                onChange={(e) => setSelectedCompanyId(parseInt(e.target.value))}
                className="w-full px-4 py-2.5 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ borderColor: '#E5E7EB' }}
                required
              >
                <option value="">Select a company</option>
                {companies.map(company => (
                  <option key={company.id} value={company.id}>{company.name}</option>
                ))}
              </select>
            </div>

            {/* File Upload Component */}
            {selectedCompanyId && (
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: '#1F2937' }}>
                  Upload Files
                </label>
                <FileUpload
                  companyId={selectedCompanyId}
                  onUploadComplete={handleUploadComplete}
                  acceptedTypes={['.pdf', '.docx', '.xlsx', '.txt', '.doc', '.xls', '.csv', '.pptx', '.png', '.jpg', '.jpeg']}
                  maxFileSize={100}
                />
              </div>
            )}

            {!selectedCompanyId && (
              <div className="text-center py-8">
                <svg className="w-12 h-12 mx-auto mb-3" style={{ color: '#D1D5DB' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p className="text-sm" style={{ color: '#6B7280' }}>
                  Please select a company to upload documents
                </p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t flex-shrink-0" style={{ borderColor: '#E5E7EB' }}>
            <button
              onClick={onClose}
              className="w-full py-2 text-sm font-medium hover:underline"
              style={{ color: '#6B7280' }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
